const mutations = {
  
    ADD_POLO (state, value) {

        state.allpolos.push(value)

    },
    GET_POLOS (state, value) {

        state.allpolos = value

    },
    ADD_GRADE_POLO (state, value) {

        state.ofertagradepolos.push(value)

    },
    GET_GRADE_POLO (state, value) {

        state.allgradepolos = value

    },
    SET_POLOS_CURSO (state, value) {

        state.polosselecionados = value

    }
}

export default mutations